import { PaletteOptions } from '@material-ui/core/styles/createPalette';
import {
  createBaseThemeOptions,
  createUnifiedTheme,
  defaultTypography,
  genPageTheme,
  palettes,
} from '@backstage/theme';

// Footballco Brand Pack 2025 palette.
const brandColors = {
  black: '#212121',
  white: '#FFFFFF',
  grey: '#F1F1F1',
  blue: '#046CF6',
  blue50: '#C2D9F9',
  blue25: '#DFE9F7',
};

const fontFamily = 'Archivo, system-ui, sans-serif';

// Archivo Black for headlines, Bold for subheadings, Regular for body copy.
const typography = {
  ...defaultTypography,
  fontFamily,
  h1: { ...defaultTypography.h1, fontWeight: 900 },
  h2: { ...defaultTypography.h2, fontWeight: 900 },
};

const createFootballcoTheme = (palette: PaletteOptions) =>
  createUnifiedTheme(
    createBaseThemeOptions({
      palette,
      fontFamily,
      typography,
      defaultPageTheme: 'home',
      pageTheme: {
        home: genPageTheme({
          colors: [brandColors.black, brandColors.blue],
          shape: 'none',
        }),
      },
    }),
  );

const navigation = {
  ...palettes.light.navigation,
  background: brandColors.black,
  indicator: brandColors.blue,
  selectedColor: brandColors.white,
};

export const footballcoLightTheme = createFootballcoTheme({
  ...palettes.light,
  primary: { main: brandColors.blue },
  background: { default: brandColors.grey, paper: brandColors.white },
  link: brandColors.blue,
  linkHover: brandColors.black,
  navigation,
});

// FC Blue is below 4.5:1 on dark surfaces, so dark mode accents use FC Blue 50%.
export const footballcoDarkTheme = createFootballcoTheme({
  ...palettes.dark,
  primary: { main: brandColors.blue50 },
  link: brandColors.blue50,
  linkHover: brandColors.blue25,
  navigation: { ...navigation, indicator: brandColors.blue50 },
});
